import { render, staticRenderFns } from "./ViewersButton.vue?vue&type=template&id=67d4aef2&scoped=true&"
import script from "./ViewersButton.vue?vue&type=script&lang=js&"
export * from "./ViewersButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d4aef2",
  null
  
)

export default component.exports